export default {
  data() {
    return {
      window: {
        width: 0
      }
    }
  },
  computed: {
    isPc() {
      return this.window.width > 768
    },
    isTablet() {
      return this.window.width > 480 && this.window.width <= 768
    },
    isMobile() {
      return this.window.width <= 480
    }
  },
  mounted() {
    window.addEventListener('resize', this.handleResize)
    this.handleResize()
  },
  destroyed() {
    window.removeEventListener('resize', this.handleResize)
  },
  methods: {
    handleResize() {
      this.window.width = window.innerWidth
    }
  }
}
